import { API_URL } from "@/config/constants";
import axios from "axios";
import {
    IAdminAnalyticsEmbed,
    IAdminOrganizationContextResponse,
    IAdminStats,
} from "./admin.types";

const API = `${API_URL}/admin`;

export const readStats = async () => {
    const result = await axios.get<IAdminStats>(`${API}/stats`);
    return result.data;
};

export const readAnalyticsEmbed = async () => {
    const result = await axios.get<IAdminAnalyticsEmbed>(
        `${API}/analytics-embed`
    );
    return result.data;
};

export const proxyAdminIntoOrganization = async (orgId: number) => {
    const result = await axios.post(`${API}/proxy/${orgId}`);
    return result.data;
};

export const getAdminProxy = async () => {
    const result = await axios.get<IAdminOrganizationContextResponse>(
        `${API}/proxy`
    );
    return result.data;
};

export const clearAdminProxy = async () => {
    const result = await axios.delete(`${API}/proxy`);
    return result.data;
};
